import script from "./ActivityListBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityListBase.vue?vue&type=script&setup=true&lang=js"

import "./ActivityListBase.vue?vue&type=style&index=0&id=3441c29e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3441c29e"]])

export default __exports__